import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Row, Col } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll"
import RockStarSeoImg from "../../images/rock-star-seo.svg"
import EssentialsPageStyle from "./essentials-page.module.scss"

const RockStarSeo = () => (
    <StaticQuery query={graphql`
        query RockstarSEO{
            contentfulTheEssentialsPage{
                essentialsReference{
                 sectionContent2{
                    subtitle{
                        subtitle
                    }
                    sectionParagraph{
                        json
                    }
                }
            }
        }
    }
`}
    render={data =>(
    <div className={EssentialsPageStyle.sectionDiv}>
        <Row>
            <Col className={EssentialsPageStyle.rockStarSeoCol1} md={5} sm={6}>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <RockStarSeoImg className={EssentialsPageStyle.rockStarSeoImg} />
                </ScrollAnimation>
            </Col>
            <Col className={EssentialsPageStyle.rockStarSeoCol2} md={7} sm={6}>
                <h3 className={EssentialsPageStyle.sectionTitleLeftAlign}>{data.contentfulTheEssentialsPage.essentialsReference.sectionContent2.subtitle.subtitle}</h3>
                <div className={EssentialsPageStyle.sectionDescriptionLeftAlign}>
                    {documentToReactComponents(data.contentfulTheEssentialsPage.essentialsReference.sectionContent2.sectionParagraph.json)}
                </div>
            </Col>
        </Row>
    </div>
    )}
    />
)

export default RockStarSeo